// extracted by mini-css-extract-plugin
module.exports = {"header":"employees_header__1DHqh","table":"employees_table__2_wmA"};